export enum SocialProviderLoginType {
  Custom = 1,
  Google = 2,
  Facebook = 3,
  Apple = 4,
}

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface VerifyEmailRequest {
  token: string;
}

export interface ResendVerificationRequest {
  email: string;
}

export interface SocialMediaLoginRequest {
  socialMediaId: string;
  fullName: string;
  email: string;
  providerLoginType: SocialProviderLoginType;
  contactNumber?: string;
}

export interface CreateFamilyMemberRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  profilePhotoFileName: string;
  relationshipTypeId: number;
}

export interface CreateFamilySpaceAndMemberRequest {
  familyName: string;
  displayPictureName: string;
  welcomeMessage: string;
  members: CreateFamilyMemberRequest[];
}

export interface AuthResponseModel {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  accessToken: string;
  isVerificationPending: boolean;
  isFamilySpaceAdded: boolean;
  isFamilyMemberAdded: boolean;
  profilePicPath?: string;
}
